import { render, staticRenderFns } from "./CariView.vue?vue&type=template&id=007faea4&"
import script from "./CariView.vue?vue&type=script&lang=js&"
export * from "./CariView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports